import { MutationTree } from 'vuex';
import { State } from '@/stores/costcentres/state';
import { CostCentre } from '@/models/cost-centre';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setCostCentres = (state: State, costCentres: Array<CostCentre>) => {
        state.costCentres = costCentres;
    }
}
